const digest = 'afd653b6e4eec986a1bb6ba8cd3ec647a43ca306b4a42e36e2e960ba0742ccf5';
const css = `._marketingTilesCardWrapper_qbca0_1,._marketingTilesCard_qbca0_1{min-height:100%}._marketingTilesCardWrapper_qbca0_1>div{height:100%;width:100%}._marketingTilesWelcomeCardWrapper_qbca0_11,._marketingTilesWelcomeCardWrapper_qbca0_11>div,._marketingTilesWelcomeCardWrapper_qbca0_11>div>div{display:flex;flex:1;flex-direction:column;min-height:100%}._marketingTilesWelcomeCardWrapper_qbca0_11 ._marketingTilesCardWrapper_qbca0_1{margin-bottom:0}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'marketingTilesCardWrapper': '_marketingTilesCardWrapper_qbca0_1', 'marketingTilesCard': '_marketingTilesCard_qbca0_1', 'marketingTilesWelcomeCardWrapper': '_marketingTilesWelcomeCardWrapper_qbca0_11' };
export const marketingTilesCardWrapper = '_marketingTilesCardWrapper_qbca0_1';
export const marketingTilesCard = '_marketingTilesCard_qbca0_1';
export const marketingTilesWelcomeCardWrapper = '_marketingTilesWelcomeCardWrapper_qbca0_11';
export { css, digest };